import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-kingstone-form',
  templateUrl: './kingstone-form.component.html',
  styleUrls: ['./kingstone-form.component.scss']
})
export class KingstoneFormComponent {
  emailComponent= '@'
    fullName: string;
    email: any;
    date: any;
  firstName: any;
  lastName: any;
  dateOfBirth: any;
  courseName: any;
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<KingstoneFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
      ) { }
      ngOnInit(): void {
        if(this.data){
          this.fullName = `${this.data.firstName} ${this.data.lastName}`.toUpperCase();
          this.firstName = this.data.firstName;
          this.lastName = this.data.lastName
          this.email = this.data.email;
          this.date = this.data.date;
          this.dateOfBirth = this.data.dateOfBirth
          this.courseName = this.data.courseName
        }
      }
      close(val?: any) {
        this.dialogRef.close(val);
      }
      sendForSignature() {
        this.dialogRef.close('sendForSignature');
    }
}
